module.exports = __webpack_public_path__ + "static/media/ic_align_left.01564568.svg";